module.exports = __webpack_public_path__ + "static/img/worm-c.70bc103.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/worm-c.svg
// module id = SShR
// module chunks = 3 5